import React, { Component } from 'react';
import {
  Col,
  Row,
} from 'react-bootstrap';
import withStyles from 'isomorphic-style-loader/withStyles';
import { injectIntl } from 'react-intl';
import cx from 'classnames';

import { api, profilePhotouploadDir } from '../../../config';
import batchIcon from '/public/Icons/service-provider-chat-icon.png';
//Style
import bt from '../../../components/commonStyle.css';
import s from './MessagesItem.css';

export class MessagesItemCommon extends Component {
  render() {
    const { avatarImage, text, chatPadding, userImage } = this.props;
    return (
      <div className={cx(bt.space5)}>
        <Row>
          <Col lg={12} md={12} sm={12} xs={12}>
            <div className={cx({ [s.displayFlexSender]: chatPadding == 'left' }, { [s.displayFlexReverse]: chatPadding == 'right' })}>
              {
                userImage &&
                <div className={cx({ [s.senderBgScetion]: chatPadding == 'left' }, { [s.recsiverBgScetion]: chatPadding == 'right' }, { ['senderBgScetionRTL']: chatPadding == 'left' })}>
                  <span className={s.positionRelative}>
                    <div className={s.bgImage} style={{ backgroundImage: `url(${api.apiEndpoint + profilePhotouploadDir}small_${userImage})` }} >
                      {chatPadding == 'right' && <span><img src={batchIcon} className={s.batchIconDriver} /></span>}
                    </div>
                  </span>
                </div>
              }
              {!userImage && <div className={cx(s.avartarSectionWidth, { [s.imageRight]: chatPadding == 'right' }, 'avartarSectionWidthRTL')}>
                <span className={s.positionRelative}>
                  <img src={avatarImage} className={s.avatarImage} />
                  {chatPadding == 'right' && <span><img src={batchIcon} className={cx(s.batchIcon, 'batchIconRTL')} /></span>}
                </span>
              </div>}
              <div className={cx({ [s.senderPadding]: chatPadding == 'left' }, { [s.receiverPadding]: chatPadding == 'right' }, { ['receiverPaddingRTL']: chatPadding == 'right' }, { ['senderPaddingRTL']: chatPadding == 'left' })}>
                {text}
              </div>
            </div>
          </Col>
        </Row>
      </div>
    )
  }
}

export default injectIntl(withStyles(bt, s)((MessagesItemCommon)));